import React from 'react';
import Fade from '@material-ui/core/Fade';
import Base, { CopyContainer, FADE_TIMEOUT, H2, Icon, ImgContainer, P, Root } from '../Base';

class Farewell extends Base {
  static isVisible = () => true;

  icon = '/images/insurance_tutorial/11_end.svg';

  render = () => {
    return (
      <Fade in timeout={FADE_TIMEOUT}>
        <Root>
          <ImgContainer>
            <Icon src={this.icon} />
          </ImgContainer>

          <CopyContainer>
            <H2>You've got this</H2>
            <P>If you weren't already, you're now an insurance pro.</P>

            <P>Ever need a refresher on how your insurance works? Come back here any time!</P>
          </CopyContainer>
        </Root>
      </Fade>
    );
  };
}

export default Farewell;
